import React from "react";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useNavigate } from "react-router-dom";

interface IProps {
  title: string;
}

const Header = ({ title }: IProps) => {
  const navigate = useNavigate();

  return (
    <header className="container">
      <span>{title}</span>
      <span className="return-to-home" onClick={() => navigate("/Dashboard")}>
        <ExitToAppIcon fontSize="small" />
      </span>
    </header>
  );
};

export default Header;
